import * as React from "react";
import FormService from './services/formService';
import { Button, Form, FormGroup, Col } from 'reactstrap';
import TwoColumnFormSection from './twoColumnFormSection';
import ThreeColumnFormSection from './threeColumnFormSection';
import DefaultColumnFormSection from './defaultColumnFormSection';
import FourColumnFormSection from './fourColumnFormSection';
import URLSearchParams from '@ungap/url-search-params';
import FormComponent from './formComponent';
import FormModalComponent from './formModalComponent';

class Form2StepsComponent extends React.Component {

    constructor(props) {
        super(props);

        this.formService = new FormService(this.props.apiEndpoint);

        this.formElementRefs = {};
        this.sectionElementRefs = {};

        this.recaptchaColumnName = null;

        this.state = {
            showSecondForm: false,
            form2InitialValues: {}
        }

        this.onForm1Submit = this.onForm1Submit.bind(this);
        this.onForm2Submit = this.onForm2Submit.bind(this);
        this.hideModal = this.hideModal.bind(this);
    }




    onForm1Submit(formData) {
        console.log('onForm1Submit', formData);
        this.setState({
            showSecondForm: true,
            form2InitialValues: formData
        });
    }

    onForm2Submit() {

    }
    hideModal() {
        this.setState({ showSecondForm: false });
    }


    render() {

        return (<><FormComponent
            gooleRecaptchaSitekey={this.props.gooleRecaptchaSitekey}
            showLabels={this.props.showLabels}
            apiEndpoint={this.props.apiEndpoint}
            formName={this.props.form1Name}
            culture={this.props.culture}
            siteName={this.props.siteName}
            labelsOnTop={this.props.labelsOnTop}
            contactId={this.props.contactId}
            onSubmitSuccess={this.onForm1Submit}
        />
            <FormModalComponent
                form={{
                    gooleRecaptchaSitekey: this.props.gooleRecaptchaSitekey,
                    showLabels: this.props.showLabels,
                    apiEndpoint: this.props.apiEndpoint,
                    formName: this.props.form2Name,
                    culture: this.props.culture,
                    siteName: this.props.siteName,
                    labelsOnTop: this.props.labelsOnTop,
                    contactId: this.props.contactId,
                    defaultValues: this.state.form2InitialValues,

                }}
                onSubmitSucces={this.onForm2Submit}
                hideModalToggleButton={true}
                showModal={this.state.showSecondForm}
                hideModal={this.hideModal}
                headerTitle={this.props.form2Title}
                headerSmallTitle={this.props.form2SmallTitle}
            />
        </>);
    }
}

export default Form2StepsComponent;